// makes the values consistent - replacing spaces with hyphens and setting to lower case in url
export const serializeLabel = (label) => label?.replace(/\s+/g, '-').toLowerCase();
